module.exports = __webpack_public_path__ + "img/myposition_fb_카푸.d9a38dc0.png";